import { Fade, Snackbar as MuiSnackbar, SnackbarProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { SnackbarProps };

const FADE_DURATION_MS = 240;
const AUTOHIDE_DEFAULT_MS = 3000;

const StyledSnackbar = styled(MuiSnackbar)<SnackbarProps>(() => ({}));

export function Snackbar(props: SnackbarProps) {
  return (
    <StyledSnackbar
      slots={{ transition: Fade }}
      slotProps={{
        transition: { timeout: { enter: FADE_DURATION_MS, exit: FADE_DURATION_MS } },
      }}
      autoHideDuration={AUTOHIDE_DEFAULT_MS}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      {...props}
    ></StyledSnackbar>
  );
}
